import { injectGlobal } from 'styled-components';
import theme from './theme';

injectGlobal`

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-stroke: 0;
  }

  body {
    font-family: 'Roboto';
  }

  a,
  button {
    outline: none;
    border: none;
    background: transparent;
    text-decoration: none;
    color: ${theme.colorPrimary};
  }


  h1{
    font-family: "korolev";
    font-style: normal;
    font-weight: 300;
    font-size: 48px;
    color: #FFFFFF;
    letter-spacing: 0.96px;
  }

  h2{
    font-family: "korolev";
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    color: #F57F29;
    letter-spacing: 0.2px;
  }

  h4{
    font-family: "Source Sans Pro Semi";
    font-size: 12px;
    color: #0A0203;
    letter-spacing: 2px;
    text-transform:uppercase;
    margin-bottom: 10px;

  }

  p {
  font-family:"Source Sans Pro Light";
  font-size: 18px;
  color: #0A0203;
  letter-spacing: 0;
  line-height: 27px;
  }

  @import url("https://p.typekit.net/p.css?s=1&k=qwc1aox&ht=tk&f=27919.27925.27993&a=5476827&app=typekit&e=css");

  @font-face {
  font-family:"korolev";
  src:url("https://use.typekit.net/af/44b9c0/00000000000000003b9b1a21/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff2"),url("https://use.typekit.net/af/44b9c0/00000000000000003b9b1a21/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("woff"),url("https://use.typekit.net/af/44b9c0/00000000000000003b9b1a21/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i3&v=3") format("opentype");
  font-style:italic;
  font-weight:300;
  }

  @font-face {
  font-family:"korolev";
  src:url("https://use.typekit.net/af/d575c3/00000000000000003b9b1a22/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/d575c3/00000000000000003b9b1a22/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/d575c3/00000000000000003b9b1a22/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
  font-style:normal;
  font-weight:500;  
  }

  @font-face {
  font-family:"korolev";
  src:url("https://use.typekit.net/af/cf0a65/00000000000000003b9b1a20/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"),url("https://use.typekit.net/af/cf0a65/00000000000000003b9b1a20/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"),url("https://use.typekit.net/af/cf0a65/00000000000000003b9b1a20/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
  font-style:normal;
  font-weight:300;
  }

  @font-face{
    font-family: "Source Sans Pro Semi";
    src: url('/assets/fonts/SourceSansPro-SemiBold.woff2') format('woff2'),
      url('/assets/fonts/SourceSansPro-SemiBold.woff') format('woff');
  }

    @font-face{
    font-family: "Source Sans Pro Light";
    src: url('/assets/fonts/SourceSansPro-Light.woff2') format('woff2'),
      url('/assets/fonts/SourceSansPro-Light.woff') format('woff');
  }

     @font-face{
    font-family: "Source Sans Pro Regular";
    src: url('/assets/fonts/SourceSansPro-Regular.woff2') format('woff2'),
      url('/assets/fonts/SourceSansPro-Regular.woff') format('woff');
  }
  @font-face {
    font-family: 'Roboto';
    src: url('/assets/fonts/Roboto-Regular.woff2') format('woff2'),
      url('/assets/fonts/Roboto-Regular.woff') format('woff');
  }

  .gmnoprint a, .gmnoprint span, .gm-style-cc {
    display: none;
  }
  .gmnoprint div {
    background: none !important;
  }

`;



// WEBPACK FOOTER //
// ./src/styles/global.js